export const WRITE_QUEUE_CHANGE_EVENT = "aera-dt-write-queue-change";
export const WORKSPACE_ACTIVITY_REFRESH_EVENT = "aera:workspace-activity-refresh";

export type WorkspaceActivityRefreshDetail = {
  workspaceId?: string | null;
};

export function notifyWorkspaceActivityRefresh(
  workspaceId?: string | null,
): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(WORKSPACE_ACTIVITY_REFRESH_EVENT, {
      detail: { workspaceId } satisfies WorkspaceActivityRefreshDetail,
    }),
  );
}

export function workspaceActivityRefreshMatches(
  targetWorkspaceId: string | null | undefined,
  detail?: WorkspaceActivityRefreshDetail | null,
): boolean {
  const ws = targetWorkspaceId?.trim() ?? "";
  if (!ws) return false;
  const eventWs = detail?.workspaceId?.trim() ?? "";
  if (!eventWs) return true;
  return eventWs === ws;
}
